import { useState } from "react";

const StarRatingPicker = ({ initialRating = 0, onRatingChange }) => {
  const [rating, setRating] = useState(initialRating);
  const [hover, setHover] = useState(null);

  const handleMouseOver = (index) => {
    setHover(index + 1);
  };

  const handleMouseOut = () => {
    setHover(null);
  };

  const handleClick = (index) => {
    setRating(index + 1);
    onRatingChange(index + 1);
  };

  return (
    <div className="flex gap-1">
      {Array.from({ length: 5 }).map((_, index) => (
        <svg
          key={index}
          className={`w-5 h-10 cursor-pointer transition-colors ${
            (hover || rating) > index ? "text-amber-400" : "text-gray-300"
          }`}
          onClick={() => handleClick(index)}
          onMouseOver={() => handleMouseOver(index)}
          onMouseOut={handleMouseOut}
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 18"
        >
          <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
        </svg>
      ))}
    </div>
  );
};

export default StarRatingPicker;
